import {  Heading, VStack, HStack, Box, Flex, Text, Icon, Image} from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import { useState, useEffect } from "react";
import { keyframes } from "@emotion/react";


const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const steps = [
    {
      number: "1",
      title: "Login",
      description: "Sign in with your phone number or email and password"
    },
    {
      number: "2",
      title: "Choose Sending Currency",
      description: "Select the currency you want to exchange from your wallet"
    },
    {
      number: "3",
      title: "Choose Receiving Currency",
      description: "Select the currency you want to receive in your wallet"
    },
    {
      number: "4",
      title: "Confirm Exchange",
      description: "Review the exchange rate and confirm your transaction"
    },
    {
      number: "5",
      title: "Wallet Balance",
      description: "View your updated multi-currency wallet balances"
    }
  ];


const ExchangeSteps = () => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % 5);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return ( 
    <FullScreenSection
        justifyContent="center"
        alignItems="center"
        isDarkBackground={false}
        backgroundColor="gray.50"
        py={100}
    >
        <VStack spacing={12} width="100%" maxW="1200px">
        <Heading fontSize={{ base: "2rem", md: "2.5rem", lg: "3rem" }} fontWeight="bold" textAlign="center">
            Not ready to transfer yet? Lock in best rates by swapping between your multi-currency wallets
        </Heading>
        <Text fontSize={{ base: "1rem", md: "1.1rem", lg: "1.2rem" }} color="gray.600" textAlign="center">
            Exchange currencies instantly within your Swiftchang wallet
        </Text>

        <Flex 
            width="100%" 
            gap={12} 
            alignItems="center" 
            justifyContent="space-between"
            flexDirection={{ base: "column", md: "row" }}
        >
            {/* Steps List */}
            <VStack spacing={{ base: 5, md: 8 }} flex="1" align="stretch">
            {steps.map((step, index) => (
                <Flex
                key={index}
                direction={{ base: "column", sm: "row" }}
                align={{ base: "flex-start", sm: "center" }}
                gap={{ base: 3, sm: 4 }}
                p={{ base: 4, md: 6 }}
                bg={activeStep === index ? "gray.100" : "white"}
                borderRadius="lg"
                boxShadow={activeStep === index ? "lg" : "md"}
                border={activeStep === index ? "2px solid" : "1px solid"}
                borderColor={activeStep === index ? "black" : "gray.200"}
                transition="all 0.3s ease"
                cursor="pointer"
                onClick={() => setActiveStep(index)}
                _hover={{ boxShadow: "xl", transform: "scale(1.02)" }}
                >
                <Box
                    minW={{ base: "44px", md: "60px" }}
                    minH={{ base: "44px", md: "60px" }}
                    borderRadius="full"
                    bg={activeStep === index ? "black" : "gray.300"}
                    color="white"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontSize={{ base: "lg", md: "2xl" }}
                    fontWeight="bold"
                >
                    {step.number}
                </Box>
                <VStack align="flex-start" spacing={1}>
                    <Heading fontSize={{ base: "1.1rem", md: "1.3rem", lg: "1.5rem" }} fontWeight="semibold">
                    {step.title}
                    </Heading>
                    <Text color="gray.600" fontSize={{ base: "sm", md: "md" }}>{step.description}</Text>
                </VStack>
                </Flex>
            ))}
            </VStack>

             {/* Phone Mockup with Animation 
            <Box flex="1" display="flex" justifyContent="center">
            <Box
                position="relative"
                width="300px"
                height="600px"
                borderRadius="3xl"
                border="12px solid"
                borderColor="gray.800"
                bg="white"
                boxShadow="2xl"
                overflow="hidden"
            >
                Phone Notch 
                <Box
                position="absolute"
                top="0"
                left="50%"
                transform="translateX(-50%)"
                width="150px"
                height="25px"
                bg="gray.800"
                borderBottomRadius="xl"
                zIndex="10"
                />

                 Phone Screen Content 
                <Box 
                pt="30px" 
                px={4} 
                height="100%" 
                bg="gradient"
                bgGradient="linear(to-b, blue.50, white)"
                >
                 Step 0: Login 
                {activeStep === 0 && (
                    <VStack 
                    spacing={6} 
                    animation={`${fadeIn} 0.5s ease-in-out`}
                    pt={8}
                    >
                    <Heading fontSize="2xl" color="black">Login</Heading>
                    <VStack spacing={4} width="100%">
                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="white" 
                        borderRadius="md" 
                        border="2px solid"
                        borderColor="black"
                        display="flex"
                        alignItems="center"
                        px={4}
                        position="relative"
                        >
                        <Text color="gray.800" fontSize="sm">user@email.com</Text>
                        <Box
                            position="absolute"
                            right="4"
                            width="2px"
                            height="20px"
                            bg="black"
                            animation="blink 1s infinite"
                            sx={{
                            "@keyframes blink": {
                                "0%, 100%": { opacity: 1 },
                                "50%": { opacity: 0 }
                            }
                            }}
                        />
                        </Box>
                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="white" 
                        borderRadius="md" 
                        border="1px solid"
                        borderColor="gray.300"
                        display="flex"
                        alignItems="center"
                        px={4}
                        >
                        <Text color="gray.800" fontSize="sm">••••••••</Text>
                        </Box>
                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="black" 
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        cursor="pointer"
                        transition="all 0.2s"
                        _hover={{ transform: "scale(0.98)" }}
                        >
                        <Text color="white" fontWeight="bold">Login</Text>
                        </Box>
                    </VStack>
                    </VStack>
                )}

                 Step 1: Choose Sending Currency 
                {activeStep === 1 && (
                    <VStack 
                    spacing={6} 
                    animation={`${fadeIn} 0.5s ease-in-out`}
                    pt={8}
                    >
                    <Heading fontSize="xl" color="black">Exchange Currency</Heading>
                    <VStack spacing={4} width="100%">
                        <Text fontSize="sm" color="gray.600" alignSelf="flex-start">From Wallet</Text>
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        border="2px solid"
                        borderColor="black"
                        >
                        <HStack justify="space-between">
                            <HStack>
                            <Image src="/flags/ca.svg" alt="Canada flag" boxSize="30px" />
                            <Text fontWeight="bold" fontSize="lg">CAD</Text>
                            </HStack>
                            <VStack align="flex-end" spacing={0}>
                            <Text fontWeight="bold" fontSize="xl" color="black">1,000</Text>
                            <Text fontSize="xs" color="gray.500">Available: 5,000</Text>
                            </VStack>
                        </HStack>
                        </Box>
                        <Text fontSize="sm" color="gray.600" alignSelf="flex-start" mt={2}>Select Currency</Text>
                        <HStack spacing={3} width="100%" flexWrap="wrap">
                        <Box 
                            p={3} 
                            bg="white" 
                            borderRadius="md" 
                            border="1px solid" 
                            borderColor="gray.300"
                            cursor="pointer"
                            _hover={{ borderColor: "black" }}
                        >
                            <HStack>
                            <Image src="/flags/ng.svg" alt="Nigeria flag" boxSize="24px" />
                            <Text fontWeight="semibold" fontSize="sm">NGN</Text>
                            </HStack>
                        </Box>
                        </HStack>
                    </VStack>
                    </VStack>
                )}

                 Step 2: Choose Receiving Currency 
                {activeStep === 2 && (
                    <VStack 
                    spacing={6} 
                    animation={`${fadeIn} 0.5s ease-in-out`}
                    pt={8}
                    >
                    <Heading fontSize="xl" color="black">Receiving Currency</Heading>
                    <VStack spacing={4} width="100%">
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="sm" color="gray.600" mb={2}>From</Text>
                        <HStack justify="space-between">
                            <HStack>
                            <Image src="/flags/ca.svg" alt="Canada flag" boxSize="30px" />
                            <Text fontWeight="bold" fontSize="lg">CAD</Text>
                            </HStack>
                            <Text fontWeight="bold" fontSize="xl" color="black">1,000</Text>
                        </HStack>
                        </Box>
                        
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        border="2px solid"
                        borderColor="black"
                        >
                        <Text fontSize="sm" color="gray.600" mb={2}>To</Text>
                        <HStack justify="space-between">
                            <HStack>
                            <Image src="/flags/ng.svg" alt="Nigeria flag" boxSize="30px" />
                            <Text fontWeight="bold" fontSize="lg">NGN</Text>
                            </HStack>
                            <Text fontWeight="bold" fontSize="xl" color="black">1,050,000</Text>
                        </HStack>
                        </Box>
                        
                        <Box 
                        width="100%" 
                        p={3} 
                        bg="blue.50" 
                        borderRadius="md"
                        >
                        <Text fontSize="xs" color="gray.700" textAlign="center">
                            Rate: 1 CAD = 1,050 NGN
                        </Text>
                        </Box>

                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="black" 
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        cursor="pointer"
                        transition="all 0.2s"
                        _hover={{ transform: "scale(0.98)" }}
                        >
                        <Text color="white" fontWeight="bold">Continue</Text>
                        </Box>
                    </VStack>
                    </VStack>
                )}

                 Step 3: Confirm Exchange 
                {activeStep === 3 && (
                    <VStack 
                    spacing={6} 
                    animation={`${fadeIn} 0.5s ease-in-out`}
                    pt={8}
                    >
                    <Heading fontSize="xl" color="black">Confirm Exchange</Heading>
                    <VStack spacing={4} width="100%">
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="sm" color="gray.600" mb={2}>Exchange From</Text>
                        <HStack>
                            <Image src="/flags/ca.svg" alt="Canada flag" boxSize="24px" />
                            <Text fontWeight="bold">1,000.00 CAD</Text>
                        </HStack>
                        </Box>

                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="sm" color="gray.600" mb={2}>Exchange To</Text>
                        <HStack>
                            <Image src="/flags/ng.svg" alt="Nigeria flag" boxSize="24px" />
                            <Text fontWeight="bold">1,050,000.00 NGN</Text>
                        </HStack>
                        </Box>

                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="sm" color="gray.600" mb={2}>Exchange Rate</Text>
                        <Text fontWeight="bold">1 CAD = 1,050 NGN</Text>
                        </Box>

                        <Box 
                        width="100%" 
                        p={4} 
                        bg="green.50" 
                        borderRadius="md"
                        >
                        <Text fontSize="sm" color="green.700" fontWeight="semibold" textAlign="center">
                            ✓ Zero fees • Instant transfer
                        </Text>
                        </Box>

                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="black" 
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        cursor="pointer"
                        transition="all 0.2s"
                        _hover={{ transform: "scale(0.98)" }}
                        >
                        <Text color="white" fontWeight="bold">Confirm Exchange</Text>
                        </Box>
                    </VStack>
                    </VStack>
                )}

                Step 4: Wallet Balance 
                {activeStep === 4 && (
                    <VStack 
                    spacing={6} 
                    animation={`${fadeIn} 0.5s ease-in-out`}
                    pt={8}
                    >
                    <Heading fontSize="xl" color="black">My Wallets</Heading>
                    <VStack spacing={3} width="100%">
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="md"
                        border="2px solid"
                        borderColor="green.400"
                        >
                        <HStack justify="space-between" mb={2}>
                            <HStack>
                            <Image src="/flags/ng.svg" alt="Nigeria flag" boxSize="30px" />
                            <Text fontWeight="bold" fontSize="lg">NGN Wallet</Text>
                            </HStack>
                            <Text fontSize="xs" color="green.600" fontWeight="bold">+1,050,000.00</Text>
                        </HStack>
                        <Text fontWeight="bold" fontSize="2xl" color="black">₦1,900,000.00</Text>
                        </Box>

                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <HStack justify="space-between" mb={2}>
                            <HStack>
                            <Image src="/flags/ca.svg" alt="Canada flag" boxSize="30px" />
                            <Text fontWeight="bold" fontSize="lg">CAD Wallet</Text>
                            </HStack>
                            <Text fontSize="xs" color="red.600" fontWeight="bold">-1,000.00</Text>
                        </HStack>
                        <Text fontWeight="bold" fontSize="2xl" color="black">$4,000.00</Text>
                        </Box>
                    </VStack>
                    </VStack>
                )}
                </Box>
            </Box>
            </Box>*/}
        </Flex>
        </VStack>
    </FullScreenSection>)
    };

export default ExchangeSteps;
